module.exports = __webpack_public_path__ + "img/img09.52988406.jpg";